import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Navigate, Route, Routes, useParams } from 'react-router-dom'
import { Loader } from 'components'
import { Alert } from '@mui/material'
import api from 'utils/api'
import { businessPath } from 'utils/businessRoutes'
import { useIsMobile } from 'utils/UI'
import Sidebar from '../../components/Sidebar'
import BusinessForm from '../../components/BusinessForm'
import Credits from '../Credits'
import Dashboard from '../Dashboard'
import Offers from '../Offers'
import Transactions from '../Transactions'
import Info from '../Info'
import BusinessAccount from 'modules/BusinessAccount'
import * as businessActions from 'modules/Business/actions'
import { useAdminUser } from 'utils/roles'
import { Helmet } from "react-helmet-async";

const BusinessContainer = () => {
  const businesses = useSelector((state) => state.user.businesses)
  const showForm = useSelector((state) => state.ui.showBusinessForm)
  const business = useSelector((state) => state.business)
  const dispatch = useDispatch()
  const params = useParams()
  const isMobile = useIsMobile()
  const isAdmin = useAdminUser()

  const [access, setAccess] = useState(null)
  useEffect(() => {
    let current = true
    setAccess(null)
    api.get(`/business/${params.businessId}/lifecycle`).then(() => {
      if (!current) return
      setAccess({ businessId: params.businessId, allowed: true })
      dispatch(businessActions.fetchBusiness(params.businessId))
    }).catch(error => { if (current) setAccess({ businessId: params.businessId, error }) })
    return () => { current = false }
  }, [dispatch, params.businessId])
  if (access?.businessId !== params.businessId) return <Loader />
  if (!access.allowed) return isAdmin && access.error?.status === 403 ? <Navigate to={`/admin/businesses/${params.businessId}`} replace /> : <Alert severity="error">This business is unavailable or is not associated with your account.</Alert>

  if (business.isLoading || String(business.requestedBusinessId) !== params.businessId) {
    return <Loader />
  }

  if (business.loadError) return <Alert severity="error">This business could not be loaded. Please try again.</Alert>

  if (String(business.businessId) !== params.businessId) return <Loader />

  if (!business.organizationId || String(business.organizationId) !== params.organizationId) {
    return <Alert severity="error">This business does not belong to the selected account.</Alert>
  }

  return (
    <div style={{ height: '100vh', overflow: 'auto', background: '#fcfcfc' }}>
      <Helmet>
        <title>My business - HiddenUnderGround</title>
      </Helmet>
  
      {!isMobile && <Sidebar businesses={businesses} />}
  
      <Routes>
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="offers" element={<Offers />} />
        <Route path="payments" element={<Credits />} />
        <Route path="transactions" element={<Transactions />} />
        <Route path="profile" element={<Info business={business} />} />
        <Route path="account" element={<BusinessAccount embedded />} />
        
        
        <Route index element={<Navigate to={businessPath(business.businessId, business.organizationId, 'dashboard')} replace />} />
      </Routes>
  
      {showForm && <BusinessForm />}
    </div>
    
  );
}

export default BusinessContainer
